var classes = {"cartBadgeRoot":"UEOHe"};

export { classes as default };
